export default __webpack_public_path__ + "static/media/milestone 1000.80558580.svg";